
import UiAccordion from "@/components/UI/UiAccordion.vue";
import UiAccordionItem from "@/components/UI/UiAccordionItem.vue";
export default {
  components: {
    UiAccordion,
    UiAccordionItem,
  },
  props: {
    productData: {
      type: Object,
      required: true,
    },
    detailsMapedData: {
      type: Array,
      default: () => [],
    },
  },
};
